import React from "react";
import { Button } from "@/components/ui/button";
import { Accordion } from "@/components/ui/accordion";
import RecentActivityWidget from "../RecentActivityWidget";
import { PropertiesSection } from "./sections/PropertiesSection";
import { InquiriesSection } from "./sections/InquiriesSection";
import { DevelopmentsSection } from "./sections/DevelopmentsSection";
import { AppointmentsSection } from "./sections/AppointmentsSection";
import { RequestsSection } from "./sections/RequestsSection";
import { canPublishPropertyRequests } from "../../constants/plans";

const SharedSections = ({
  user,
  currentUser,
  properties,
  deletedProperties,
  inquiries,
  developments,
  deletedDevelopments,
  appointments,
  myRequests,
  expandedRequest,
  requestResponses,
  handleDeleteProperty,
  handleRestoreProperty,
  handleToggleActive,
  handleToggleFeatured,
  handleDeleteDevelopment,
  handleRestoreDevelopment,
  handleAppointmentStatus,
  openEditAppointment,
  loadResponses,
  updateRequestStatus,
  setExpandedRequest,
  navigate,
  archiveInquiry,
  limitedMode = false,
}) => {
  const requestsWithResponses = myRequests.filter(
    (req) => (req.responses_count || 0) > 0,
  );

  if (limitedMode) {
    return (
      <Accordion
        type="multiple"
        defaultValue={["properties"]}
        className="space-y-3"
      >
        <PropertiesSection
          properties={properties}
          deletedProperties={deletedProperties}
          currentUser={currentUser}
          sectionTitle={
            user?.role === "broker"
              ? "Mis Propiedades Listadas"
              : "Mis Propiedades"
          }
          navigate={navigate}
          handleDeleteProperty={handleDeleteProperty}
          handleRestoreProperty={handleRestoreProperty}
          handleToggleActive={handleToggleActive}
          handleToggleFeatured={handleToggleFeatured}
        />
      </Accordion>
    );
  }

  return (
    <>
      <RecentActivityWidget properties={properties} inquiries={inquiries} />

      {requestsWithResponses.length > 0 && (
        <div
          className="bg-emerald-50 border border-emerald-200 rounded-lg p-4 mb-3"
          data-testid="request-responses-summary"
        >
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
            <div>
              <p className="text-sm font-semibold text-emerald-800">
                Tienes {requestsWithResponses.length} búsqueda(s) con nuevas
                respuestas
              </p>
              <p className="text-xs text-emerald-700 mt-1">
                Revisa las respuestas en tu dashboard y marca la búsqueda como
                resuelta cuando cierres la necesidad.
              </p>
            </div>
            <Button
              size="sm"
              variant="outline"
              onClick={() => loadResponses(requestsWithResponses[0].id)}
            >
              Ver respuestas
            </Button>
          </div>
        </div>
      )}

      <Accordion
        type="multiple"
        defaultValue={["properties"]}
        className="space-y-3"
      >
        <PropertiesSection
          properties={properties}
          deletedProperties={deletedProperties}
          currentUser={currentUser}
          sectionTitle={
            user?.role === "broker"
              ? "Mis Propiedades Listadas"
              : "Mis Propiedades"
          }
          navigate={navigate}
          handleDeleteProperty={handleDeleteProperty}
          handleRestoreProperty={handleRestoreProperty}
          handleToggleActive={handleToggleActive}
          handleToggleFeatured={handleToggleFeatured}
        />

        <InquiriesSection
          inquiries={inquiries}
          archiveInquiry={archiveInquiry}
        />

        {(user?.role === "developer" || user?.role === "admin") && (
          <DevelopmentsSection
            developments={developments}
            deletedDevelopments={deletedDevelopments}
            navigate={navigate}
            handleDeleteDevelopment={handleDeleteDevelopment}
            handleRestoreDevelopment={handleRestoreDevelopment}
          />
        )}

        {(user?.role === "developer" || user?.role === "admin") && (
          <AppointmentsSection
            appointments={appointments}
            handleAppointmentStatus={handleAppointmentStatus}
            openEditAppointment={openEditAppointment}
          />
        )}

        {(canPublishPropertyRequests(currentUser) || myRequests.length > 0) && (
          <RequestsSection
            currentUser={currentUser}
            myRequests={myRequests}
            expandedRequest={expandedRequest}
            requestResponses={requestResponses}
            loadResponses={loadResponses}
            updateRequestStatus={updateRequestStatus}
            setExpandedRequest={setExpandedRequest}
            navigate={navigate}
          />
        )}
      </Accordion>
    </>
  );
};

export { SharedSections };
